import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';

interface InfoBlockForChangeNowProps {
  untilDate: string;
  daysRemain: string;
  moreThanHalfMonth: boolean;
  isMonthCountChanged: boolean;
  handleChangeCountMonth: (amount: number) => void;
  availableInstantChanges: number | undefined;
  payAmount?: number;
  price?: number;
}

export const InfoBlockForChangeNow: FC<InfoBlockForChangeNowProps> = ({
  price,
  untilDate,
  daysRemain,
  payAmount,
  moreThanHalfMonth,
  isMonthCountChanged,
  handleChangeCountMonth,
  availableInstantChanges,
}) => {
  const { t } = useTranslation();

  return (
    <div className="payment__content__options__activation-period__info-block arrow">
      {moreThanHalfMonth || isMonthCountChanged ? (
        <div className="payment__content__options__activation-period__info-block__block-before">
          <p>
            {price === 0
              ? t('servicePayment.infoBlockSuspensionActivate')
              : t(`servicePayment.${payAmount ? 'infoBlockMoreHalfMonthPay' : 'infoBlockMoreHalfMonthActivate'}`, {
                  until: untilDate,
                })}
            {price !== 0 && (
              <>
                <br />
                {availableInstantChanges && availableInstantChanges > 1
                  ? t('servicePayment.availableInstantChanges', { val: availableInstantChanges })
                  : t('servicePayment.lastAvailableInstantChange')}
              </>
            )}
          </p>
        </div>
      ) : (
        <div className="payment__content__options__activation-period__info-block__block-after">
          <p>
            {price === 0 ? (
              t('servicePayment.infoBlockSuspensionActivate')
            ) : (
              <>
                {t('servicePayment.infoBlockLessHalfMonth', { val: daysRemain })} {t('servicePayment.addNextMonth')}
              </>
            )}
            {price !== 0 && (
              <>
                <br />
                {availableInstantChanges && availableInstantChanges > 1
                  ? t('servicePayment.availableInstantChanges', { val: availableInstantChanges })
                  : t('servicePayment.lastAvailableInstantChange')}
              </>
            )}
          </p>
          {price !== 0 && (
            <CustomMUIButton
              label={t('buttons.add')}
              className={ButtonClassNames.PrimaryFulfilledSmall}
              handleClick={() => handleChangeCountMonth(2)}
              isBold
            />
          )}
        </div>
      )}
    </div>
  );
};
